import {
  CollaborativeDocumentFragment,
  PartialCollaborationV1CollaborativeDocumentInput,
  UpdateCollaborativeDocumentMutation,
  useUpdateCollaborativeDocumentMutation,
  withStandardUpdateHook,
} from '@spotify/confidence-graphql';

export const useUpdateCollaborativeDocument = withStandardUpdateHook<
  UpdateCollaborativeDocumentMutation,
  CollaborativeDocumentFragment,
  'updateCollaborativeDocument',
  PartialCollaborationV1CollaborativeDocumentInput
>(useUpdateCollaborativeDocumentMutation, 'updateCollaborativeDocument');
